import React, {useState} from 'react';
import {
   Image,
   Text,
   TouchableOpacity,
   View,
   StyleSheet,
   Dimensions,
   Platform,
} from 'react-native';
import {
   moduleCountBGColor,
   drawerListBackgroundColor,
   courseListBGColor,
   lockedCourseBGColor,
   courseSerialNumberColor,
   FONT_FAMILY_REGULAR,
   isMacOS,
   WHITE_ICON_HOVER_TINT_COLOR,
   WHITE_TEXT_HOVER_COLOR,
   parseSpecialChar,
} from '../../utils/utils';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {isWindows} from 'react-device-detect';

const {width, height} = Dimensions.get('window');
const rowSize =
   Dimensions.get('window').height > Dimensions.get('window').width ? 40 : 48;
const isLandscapeMode =
   Dimensions.get('window').height > Dimensions.get('window').width
      ? false
      : true;
const isWeb = Platform.OS === 'web';
const CourseDetailItem = ({
   icon,
   title,
   ModuleSlidesCount,
   iconTintColor,
   titleColor,
   isSelected,
   index,
   locked,
   isLandscape,
   isCourseModuleCompleted,
   isPreTestEnable,
   preTestInitiat,
}) => {
   const isModifyUIBasedOnPretest = isPreTestEnable && !locked;
   const moduleSlidesCount = isModifyUIBasedOnPretest
      ? 'PRE-TEST'
      : ModuleSlidesCount;
   var boolData = isCourseModuleCompleted;
   const [isRowHover, setRowHover] = useState(false);

   if (typeof boolData === 'string') {
      boolData = boolData === 'false' ? false : true;
   }
   const isLandscapeMode = useSelector(selectScreenOrientation);
   return (
      <View
         onMouseEnter={() => setRowHover(true)}
         onMouseLeave={() => setRowHover(false)}
         style={{
            paddingHorizontal:
               Platform.OS === 'windows'
                  ? 24
                  : isLandscapeMode
                  ? isWeb
                     ? 24
                     : 16
                  : 16,
         }}>
         {/** Unlocked courses and locked courses have different parent views */}
         {!locked ? (
            <View style={styles.item}>
               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'flex-start',
                     alignItems: 'center',
                     width: isLandscapeMode
                        ? !(isWeb || isWindows || isMacOS)
                           ? '65%'
                           : '70%'
                        : '63%',
                     ...Platform.select({
                        web: {
                           justifyContent: 'flex-start',
                        },
                     }),
                  }}>
                  <View
                     style={{
                        backgroundColor: '#000000',
                        borderRadius: 4,
                        height: rowSize,
                        width: rowSize,
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                     }}>
                     <Text style={[styles.serialTitle]}>
                        {parseInt(index) + 1}
                     </Text>
                  </View>
                  {/** textWidht = full Available width - margin - (serail view + module count view + button view) - (other view margins) */}
                  <Text
                     numberOfLines={1}
                     style={[
                        styles.title,
                        {
                           width: isLandscape
                              ? width * 0.4 -
                                16 * 2 -
                                (rowSize + 64 + rowSize) -
                                (10 + 10 * 2 + 5)
                              : width -
                                (isModifyUIBasedOnPretest ? 30 * 2 : 16 * 2) -
                                (rowSize + 64 + rowSize) -
                                (10 + 10 * 2 + 5),
                           ...Platform.select({
                              web: {
                                 width:
                                    isModifyUIBasedOnPretest && !isLandscape
                                       ? '60%'
                                       : '100%',
                                 marginLeft: 16,
                                 marginRight: isLandscape ? 8 : 0,
                              },
                           }),
                        },
                        isRowHover && {color: WHITE_TEXT_HOVER_COLOR},
                     ]}>
                     {parseSpecialChar(title)}
                  </Text>
               </View>

               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'flex-end',
                     alignItems: 'center',
                     width: isLandscapeMode
                        ? !(isWeb || isWindows || isMacOS)
                           ? '35%'
                           : '30%'
                        : '37%',
                  }}>
                  <TouchableOpacity onPress={() => preTestInitiat(true)}>
                     <View
                        style={{
                           backgroundColor: moduleCountBGColor,
                           borderRadius: Platform.OS === 'windows' ? 15 : 32,
                           height: 32,
                           width: isModifyUIBasedOnPretest
                              ? 95
                              : !isLandscape
                              ? 64
                              : 72,
                           alignContent: 'center',
                           alignItems: 'center',
                           justifyContent: 'space-around',
                           flexDirection: 'row',
                           marginHorizontal: 8,
                        }}>
                        <Image
                           style={{
                              marginLeft: 10,
                              width: 16,
                              height: 16,
                              ...Platform.select({
                                 web: {
                                    width: 16,
                                    height: 16,
                                    tintColor:
                                       isRowHover &&
                                       WHITE_ICON_HOVER_TINT_COLOR,
                                 },
                              }),
                           }}
                           source={
                              isModifyUIBasedOnPretest
                                 ? require('../../assets/noun.png')
                                 : require('../../assets/modulesCountIcon.png')
                           }
                        />
                        <Text
                           style={[
                              styles.moduleCountTitle,
                              isModifyUIBasedOnPretest && {
                                 fontSize: 9,
                              },
                              isRowHover && {color: WHITE_TEXT_HOVER_COLOR},
                              isWindows &&
                                 !isWeb && {
                                    marginTop: 4,
                                 },
                           ]}>
                           {moduleSlidesCount}
                        </Text>
                     </View>
                  </TouchableOpacity>
                  <View
                     style={{
                        backgroundColor: boolData ? '#26E555' : '#808080',
                        borderRadius: 4,
                        height: !isLandscape ? 32 : 40,
                        width: !isLandscape ? 32 : 40,
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginVertical: 4,
                        marginEnd: 4,
                     }}>
                     <Image
                        style={{
                           ...Platform.select({
                              web: {
                                 width: 16,
                                 height: 16,
                              },
                           }),
                        }}
                        source={require('../../assets/single_tick.png')}
                     />
                  </View>
               </View>
            </View>
         ) : (
            <View style={styles.lockedItem}>
               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'flex-start',
                     alignItems: 'center',
                     width: isLandscapeMode
                        ? !(isWeb || isWindows || isMacOS)
                           ? '65%'
                           : '70%'
                        : '63%',
                     ...Platform.select({
                        web: {
                           justifyContent: 'flex-start',
                        },
                     }),
                  }}>
                  <Image
                     style={{width: rowSize, height: rowSize}}
                     source={require('../../assets/lock.png')}
                  />
                  {/** textWidht = full Available width - margin - (serail view + module count view + button view) - (other view margins) */}
                  <Text
                     numberOfLines={1}
                     style={[
                        styles.title,
                        {
                           width: isLandscape
                              ? width * 0.4 -
                                16 * 2 -
                                (rowSize + 64 + rowSize) -
                                (10 + 10 * 2 + 5)
                              : width -
                                16 * 2 -
                                (rowSize + 64 + rowSize) -
                                (10 + 10 * 2 + 5),
                           ...Platform.select({
                              web: {
                                 width: '90%',
                                 marginLeft: 16,
                                 marginRight: isLandscape ? 8 : 0,
                              },
                           }),
                        },
                     ]}>
                     {parseSpecialChar(title)}
                  </Text>
               </View>

               <View
                  style={{
                     flexDirection: 'row',
                     justifyContent: 'flex-end',
                     alignItems: 'center',
                     width: isLandscapeMode
                        ? !(isWeb || isWindows || isMacOS)
                           ? '35%'
                           : '30%'
                        : '37%',
                  }}>
                  <View
                     style={{
                        backgroundColor: moduleCountBGColor,
                        borderRadius: Platform.OS === 'windows' ? 15 : 32,
                        height: 32,
                        width: !isLandscape ? 64 : 72,
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        flexDirection: 'row',
                        marginHorizontal: 8,
                     }}>
                     <Image
                        style={{
                           marginLeft: 10,
                           width: 16,
                           height: 16,
                           ...Platform.select({
                              web: {
                                 width: 16,
                                 height: 16,
                              },
                           }),
                        }}
                        source={
                           isModifyUIBasedOnPretest
                              ? require('../../assets/noun.png')
                              : require('../../assets/modulesCountIcon.png')
                        }
                     />
                     <Text
                        style={[
                           styles.moduleCountTitle,
                           isModifyUIBasedOnPretest && {fontSize: 10},
                        ]}>
                        {moduleSlidesCount}
                     </Text>
                  </View>

                  <View
                     style={{
                        backgroundColor: boolData ? '#26E555' : '#808080',
                        borderRadius: 4,
                        height: !isLandscape ? 32 : 40,
                        width: !isLandscape ? 32 : 40,
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginVertical: 4,
                        marginEnd: 4,
                     }}>
                     <Image
                        style={{
                           ...Platform.select({
                              web: {
                                 width: 16,
                                 height: 16,
                              },
                           }),
                        }}
                        source={require('../../assets/single_tick.png')}
                     />
                  </View>
               </View>
            </View>
         )}
      </View>
   );
};

const styles = StyleSheet.create({
   item: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 0,
      minHeight: 40,
      backgroundColor: drawerListBackgroundColor,
      borderRadius: 4,
   },
   lockedItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 0,
      minheight: 40,
      backgroundColor: '#rgb(62,61,65)',
      borderTopLeftRadius: isWeb ? 24 : 20,
      borderBottomLeftRadius: isWeb ? 24 : 20,
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
   },
   title: {
      fontSize: !isLandscapeMode ? 12 : 16,
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 10,
      color: 'white',
      fontWeight: '600',
   },
   serialTitle: {
      fontSize: !isLandscapeMode ? 16 : 24,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: courseSerialNumberColor,
      textAlign: 'center',
   },
   moduleCountTitle: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      marginLeft: 10,
      color: 'white',
      fontWeight: '700',
      marginRight: 10,
   },
});

export default CourseDetailItem;
